import { NavLink } from "react-router";
import Icon from "../../components/Icon";
import KeyboardArrowRight from "../../components/icons/keyboard_arrow_right.svg?react";
import { Setup } from "../../http/onlyclicksApi";
import styles from "./SetupList.module.css";

interface Props {
  setups: Record<number, Setup[]> | undefined;
  onClick?: (setup: Setup) => void;
}

const SetupList = ({ setups, onClick }: Props) => {
  return (
    <ul>
      {setups &&
        Object.entries(setups)
          .sort(([a], [b]) => Number(b) - Number(a)) // Sort by year descending
          .map(([year, setups]) => {
            return (
              <li key={year} className={styles.group}>
                <div className={styles.groupLabel}>{year}</div>
                <ul className={styles.setups}>
                  {setups.map((setup) => {
                    return (
                      <li key={setup.id}>
                        {onClick ? (
                          <div
                            onClick={() => {
                              onClick(setup);
                            }}
                            className={styles.setup}
                          >
                            {setup.name}
                            <Icon
                              glyph={KeyboardArrowRight}
                              className={styles.arrowRight}
                            />
                          </div>
                        ) : (
                          <NavLink to={setup.id} className={styles.setup}>
                            {setup.name}
                            <Icon
                              glyph={KeyboardArrowRight}
                              className={styles.arrowRight}
                            />
                          </NavLink>
                        )}
                      </li>
                    );
                  })}
                </ul>
              </li>
            );
          })}
    </ul>
  );
};

export default SetupList;
